/**
 * Created by mgoria on 02/01/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownRumEventException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when failed to 'guess' RUM event 'type'
 */
let UnknownRumEventException = exports.UnknownRumEventException = function (_LogDriverException) {
  _inherits(UnknownRumEventException, _LogDriverException);

  /**
   * @param {Object} event
   */
  function UnknownRumEventException(event) {
    _classCallCheck(this, UnknownRumEventException);

    return _possibleConstructorReturn(this, (UnknownRumEventException.__proto__ || Object.getPrototypeOf(UnknownRumEventException)).call(this, `Failed to 'guess' event type for ${JSON.stringify(event)} event.`));
  }

  return UnknownRumEventException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/UnknownRumEventException.js
// module id = 404
// module chunks = 0